<template>
	<div id="container">
		<div id="subtitleSettingContainer">
			<header class="mdc-top-app-bar position-init">
				<div class="mdc-top-app-bar__row">
					<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
						<a class="material-icons mdc-top-app-bar__navigation-icon" @click="onClose()" @keypress="onClose()" >close</a>
					</section>
					
					<section class="mdc-top-app-bar__section title">
						<div class="mdc-top-app-bar__title">
							{{$t('1109')}}
							<!-- Subtitle Setting -->
						</div>                
					</section>

					<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
						<a class="material-icons mdc-top-app-bar__navigation-icon"></a>
					</section>
				</div>
				
			</header>
			<section id="subtitleSettingContents">
				<div id="subtitles">
					<!-- {{subtitles}} -->
					<div class="subtitle-list">
						<div>
							<ul>
								<li v-if="subtitles.length > 0" style="color: var(--DocumentWhite);font-size: 22px">
									<div class="t-subtitle2">
										Subtitle
										<!-- {{$t('1092')}} -->
										<!-- Main subtitles -->

									</div>
								</li>
								<li @click="setFirstSubtitle('')" :class="{'active': firstSubtitle === ''}" @keypress="setFirstSubtitle('')"  tabindex="0">
									<div class="list-check"> 
										{{$t('1110')}}
										<!-- Not used -->
									   
									 <i  v-if="firstSubtitle === ''" class="material-icons pdl-8">check</i>
									</div>
								</li>
								<li v-for="(subtitle, index) in subtitles" :key="index"  tabindex="0" @click="setFirstSubtitle(subtitle.language.value)" @keypress="setFirstSubtitle(subtitle.language.value)"  :class="{'active': firstSubtitle === subtitle.language.value }">
									<div class="list-check">{{subtitle.language.text}} <i  v-if="firstSubtitle === subtitle.language.value" class="material-icons pdl-8">check</i></div>
									
								</li>
								
							</ul>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>


export default {
	props: ['subtitles', 'setedFirstSubtitle'],
	data() {
		return {
			firstSubtitle: '',
		}
	},
	
	mounted() {
		this.firstSubtitle = this.setedFirstSubtitle
	},
	
	methods: {
		onClose: function () {
			this.$emit('subtitle-settings-toggle');
		},
		// set sub title
		setFirstSubtitle(language) {
			if (this.firstSubtitle === language) {
				this.firstSubtitle = ''
			}else {
				this.firstSubtitle = language
			}
			this.$emit('setSubtitles',this.$data)
		},

	}
}
</script>